import React, { useState, useEffect } from 'react';
import Header from './Header';
import './mainPage.css';

import shoesImg from './cat/shoes_cat_1.jpeg';
import pantsImg from './cat/pants_cat_1.jpg';
import hoodiesImg from './cat/hoodies_cat_1.jpg';
import shirtsImg from './cat/shirt_cat_1.jpg.webp';
import miscImg from './cat/acc_cat_1.jpg.webp';
import accessoriesImg from './cat/acc_pic_1.jpg';



const GOOGLE_SHEET_API_URL =
    'https://script.google.com/macros/s/AKfycbzz7FK7t8J1FZTgShAOTkQdxuSobTnaOQxLYKgXXN2PU496ixAWKRBdD_rHqo1_I961/exec';

const categoryImages = [
    { name: 'shoes', image: shoesImg },
    { name: 'hoodies', image: hoodiesImg },
    { name: 'shirts', image: shirtsImg },
    { name: 'pants', image: pantsImg },
    { name: 'accessoire', image: accessoriesImg},
    { name: 'misc', image: miscImg }
];

const MainPage = () => {
    const [products, setProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [loading, setLoading] = useState(true);
    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                // Check if products are already cached
                const cachedProducts = localStorage.getItem('products');
                if (cachedProducts) {
                    setProducts(JSON.parse(cachedProducts));
                    setLoading(false);
                    setTimeout(() => {
                        setFadeIn(true);
                    }, 50);
                    return;
                }

                // Fetch from server if no cached data
                const response = await fetch(GOOGLE_SHEET_API_URL);
                const data = await response.json();

                const parsedProducts = data.data.map((p) => ({
                    name: p.name || '',
                    link1: p.link1 || '',
                    link2: p.link2 || '',
                    price: p.price ? Number(p.price) : 0,
                    category: p.category || '',
                    image: p.image || '',
                }));

                // Save fetched data to localStorage
                localStorage.setItem('products', JSON.stringify(parsedProducts));
                setProducts(parsedProducts);
            } catch (error) {
                console.error('Error fetching products:', error);
            } finally {
                setLoading(false);
                setTimeout(() => {
                    setFadeIn(true);
                }, 50);
            }
        };

        fetchProducts();
    }, []);

    const filteredProducts = products.filter((product) => {
        if (selectedCategory !== 'All' && product.category !== selectedCategory) {
            return false;
        }
        if (
            searchTerm &&
            !product.name.toLowerCase().includes(searchTerm.toLowerCase())
        ) {
            return false;
        }
        return true;
    });

    const handleCategoryClick = (categoryName) => {
        setSelectedCategory(categoryName === selectedCategory ? 'All' : categoryName);
    };

    const handleImageClick = (link1) => {
        if (link1) {
            window.open(link1, '_blank');
        }
    };

    const bgWrapperClass = loading ? "background-wrapper" : "background-wrapper bg-dark";

    return (
        <>
            <div className={bgWrapperClass}></div>
            <div className="app-wrapper">
                <Header />

                {loading ? (
                    <div className="loading-screen"></div>
                ) : (
                    <div className={`main-page ${fadeIn ? 'fade-in' : ''}`}>
                        <div className="filter-section">
                            <input
                                type="text"
                                className="search-input"
                                placeholder="🔍"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <div className="category-images">
                                {categoryImages.map((cat) => (
                                    <div
                                        key={cat.name}
                                        className={`category-image ${
                                            selectedCategory === cat.name ? 'selected' : ''
                                        }`}
                                        onClick={() => handleCategoryClick(cat.name)}
                                    >
                                        <img src={cat.image} alt={cat.name} />
                                        <span>{cat.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="products-container">
                            {filteredProducts.map((product, index) => (

                                <div key={index} className="product-card">
                                    <a
                                        href={product.link1}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >{product.image ? (
                                        <img
                                            src={product.image}
                                            alt={product.name}
                                            className="product-image"
                                            onClick={() => handleImageClick(product.link1)}
                                        />
                                    ) : (
                                        <div className="product-placeholder">no Image</div>
                                    )}
                                    </a>

                                    <div className="product-info">
                                        <h3 className="product-name">{product.name}</h3>
                                        <p className="product-price">${product.price}</p>

                                        <div className="product-links">
                                            <a
                                                href={product.link1}
                                                className="product-button item-link"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Item Link
                                            </a>
                                        </div>
                                    </div>
                                </div>


                            ))}
                        </div>
                        <footer className="disclaimer">
                            This site does not sell or promote counterfeit goods. All links provided are solely for
                            educational purposes, helping buyers make informed decisions and avoid scams. benibuy.shop does
                            not endorse the sale of counterfeit items and encourages responsible shopping.
                        </footer>
                    </div>
                )}
            </div>
        </>
    );
};

export default MainPage;